import http from "../http-common";

export default class {
  getConvertedMember(memberType: string, isActive: boolean, eCode: string) {
    let url = `/cvent-page/convert-member-type/${memberType}/${isActive}/${eCode}`;

    return http.get(url);
  }
}